import {
  onAPiCallCreateArtRunnerEvent,
  apiCallEditArtRunnerEvent,
} from "../../../../Core/Apicall";
import moment from "moment";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../../Config/Actions/loadingActions";
export const onApiCallUpdata = async (
  formData,
  location,
  EventDetails,
  isProfileData,
  navigate,
  dispatch,
) => {
  const eventDate = moment(formData.ShowDate).format("YYYY-MM-DD"); // Ensure correct date format
  const eventTime = dayjs(formData.StartTime, "HH:mm").format("HH:mm:ss");
  const utcDate = moment(`${eventDate}T${eventTime}`)
    .utc()
    .format("YYYY-MM-DDTHH:mm:ssZ");

  const param = {
    eventDetail: {
      eventTypeId: formData.eventTypeId,
      eventName: formData.ShowName,
      eventDescription: formData.ShowDetails,
      eventImages: formData.TicketImages,
      eventStartTimeUTC: utcDate,
      eventPosterImages: formData.EventPoster,
      eventStartDate: moment(formData.ShowDate).format("DD/MM/YYYY"),
      eventStartTime: dayjs(formData.StartTime, "HH:mm").format("HH:mm:ss"),
      eventDoorOpenTime: dayjs(formData.DoorOpens, "HH:mm").format("HH:mm:ss"),
      eventEndTime: dayjs(formData.EndTime, "HH:mm").format("HH:mm:ss"),
      isMidNight: formData.isMidNight,
      isMidNightEndDate: formData.isMidNight
        ? moment(formData.ShowDate).add(1, "days").format("DD/MM/YYYY")
        : moment(formData.ShowDate).format("DD/MM/YYYY"),
      eventVisibility: formData.VisibilityType,
      requirements:
        formData.ArtRunner === "Tour"
          ? null
          : formData.PersonallyApprove === false
            ? null
            : formData.Requirements,
    },
    venueDetail: {
      venueName: formData.VenueName,
      venueAddress: formData.VenueAddress,
    },
    eventMode: {
      categoryId: formData.categoryId,
      bonusSpots: formData.ArtRunner === "Tour" ? null : true,
      noOfSpots:
        formData.ArtRunner === "Tour"
          ? null
          : formData.NumberSpots && formData.PersonallyApprove === false
            ? null
            : formData.NumberSpots,
    },
    personalApproval: {
      allowGuests: formData.ArtRunner === "Tour" ? null : formData.Guests,
      supportVenue:
        formData.ArtRunner === "Tour" ? null : formData.SupportVenue,
      allowMultipleSignup:
        formData.ArtRunner === "Tour" ? null : formData.MultipleSignup,
    },
    preAddedArtist: {
      artistId: formData.AddArtists,
    },
    scheduleEvent: {
      doRepeat: formData.ArtRunner === "Tour" ? null : formData.AutoRepeat,
      repeatType:
        formData.ArtRunner === "Tour"
          ? null
          : formData.AutoRepeat === false || formData.AutoRepeat === null
            ? null
            : formData.RepeatType,
      monthWeek:
        formData.AutoRepeat === false || formData.AutoRepeat === null
          ? null
          : formData.ArtRunner === "Tour"
            ? null
            : formData.RepeatType === "Custom"
              ? formData.WeekMonth
              : null,
      weekDay:
        formData.AutoRepeat === false || formData.AutoRepeat === null
          ? null
          : formData.ArtRunner === "Tour"
            ? null
            : formData.RepeatType === "Custom"
              ? formData.DayWeek
              : null,
      startDate:
        formData.ArtRunner === "Tour"
          ? null
          : formData.RepeatType === false || formData.RepeatType === null
            ? null
            : moment(formData.ShowDate).format("DD/MM/YYYY"),
      nextEvent:
        formData.ArtRunner === "Tour"
          ? null
          : formData.RepeatType === false || formData.RepeatType === null
            ? null
            : formData.RepeatStartDate,
      endDate:
        formData.ArtRunner === "Tour"
          ? null
          : formData.RepeatType === false || formData.RepeatType === null
            ? null
            : moment(formData.RepeatEndDate).format("DD/MM/YYYY"),
    },
    artistSignupVisibility: {
      allowArtistSignUp: formData.ArtRunner === "Showcase" ? formData.PersonallyApprove : true,
      signupVisibility:
        formData.ArtRunner === "Tour" ? null : formData.AlwaysVisible,
      visibilityStartDate:
        formData.AlwaysVisible === 3
          ? moment(formData.CustomDate).format("DD/MM/YYYY")
          : null,
      visibilityStartTime:
        formData.AlwaysVisible === 3
          ? dayjs(formData.CustomTime, "HH:mm").format("HH:mm:ss")
          : null,
      saveSettings: formData.Settings,
    },
    eventPricing: {
      eventEntry: formData.EventEntry,
      VIPPrice: formData.EventEntry === "Free" ? null : formData.VIPPrice,
      VIPSeats: formData.EventEntry === "Free" ? null : formData.VIPSeats,
      economyPrice: formData.EventEntry === "Free" ? null : formData.economyPrice,
      economySeats: formData.EventEntry === "Free" ? null : formData.economySeats,
      latestDateForPurchase: null,
      ticketPageLink: formData.EventEntry === "Free" ? null : formData.PageUrl,
      paymentProvider: formData.EventEntry === "Free" ? "Free" : formData.paymentProvider,
      currency: formData.EventEntry === "Free" ? null :formData.currency,
      exchangeRate: formData.exchangeRate || 1,
      currencySymbol: formData.EventEntry === "Free" ? null : formData.currencySymbol,
      displayEconomyPrice: formData.displayEconomyPrice || null,
      displayVipPrice: formData.displayVipPrice || null,
      freeSeats: formData.freeSeats || null,
    },
    userId: EventDetails?.userId,
    exceptFirst: formData.Expect,
    exceptSecond: formData.Expect1,
    exceptThird: formData.Expect2,
    latitude: formData.latitude,
    longitude: formData.longitude,
    status: "Submit",
  };

  if (location?.state?.AdminEvent) {
    param.userId = isProfileData.userData.userId;
    param.createdBy = "Admin";
  } else if (location?.state?.adminEventEdit) {
    param.userId = isProfileData.userData.userId;
    param.createdBy = "Admin";
  }
  if (EventDetails?.eventCreator.eventCreatorName === "Admin") {
    param.createdBy = "Admin";
  }

  if (location.state.eventId) {
    param.eventId = location.state.eventId;
  }
  dispatch(setLoadingTrue());
  try {
    let response;
    if (location?.state?.AdminEvent) {
      response = await onAPiCallCreateArtRunnerEvent(param);
      toast.success("Event Created Successfully!");
    } else if (location?.state?.adminEventEdit) {
      if (EventDetails?.selfReportEvent) {
        param.changeEvent = true;
        param.userId = isProfileData.userData.userId;
        param.createdBy = "Admin";
      }
      response = await apiCallEditArtRunnerEvent(param);
      toast.success("Event Updated Successfully!");
    } else {
      if (location.state === null) {
        response = await onAPiCallCreateArtRunnerEvent(param);
        toast.success("Event Created Successfully!");
      } else {
        if (EventDetails?.selfReportEvent) {
          param.changeEvent = true;
          param.userId = isProfileData.userData.userId;
          param.createdBy = "Admin";
        }
        response = await apiCallEditArtRunnerEvent(param);
        toast.success("Event Updated Successfully!");
      }
    }
    dispatch(setLoadingFalse());
    setTimeout(() => {
      navigate(-1);
      dispatch(setLoadingFalse());
    }, 1000);
  } catch (error) {
    dispatch(setLoadingFalse());
    console.error("API Error:", error);
  }
};
